import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { TabsComponent } from "./TabsComponent";
// import { SubscriptionIcon } from "../../Partials/Subscription/SubscriptionIcon";
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from "../../Partials/Material/TextField";
import Card from '@material-ui/core/Card';

class Companies extends Component {
  public selectedCompany: CompanyInterface = null;
  protected textFieldRef;

  public state = {
    anchorEl: null,
    isDeletePromptOpen: false,
    companiesSeparatePage: false,
    filterValue: '',
    searchInProgress: false,
    results: this.props.app.companies
  };

  constructor(public props) {
    super(props);
    this.textFieldRef = React.createRef();
  }

  public componentWillMount() {
    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });
    if (this.props.location.pathname === "/app/companies") {
      this.setState({
        companiesSeparatePage: true
      })
    }
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname === "/app/companies") {
      this.setState({
        companiesSeparatePage: true
      });
    } else {
      this.setState({
        companiesSeparatePage: false
      });
    }
  }


  protected openMenu = (event: any, company: CompanyInterface): void => {
    this.selectedCompany = company;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  protected openPrompt = (): void => {
    this.setState({
      isDeletePromptOpen: true,
      anchorEl: null
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isDeletePromptOpen: false
    });
  }

  public delete = (company: CompanyInterface): void => {
    this.closePrompt();

    return this.props.dispatch({
      type: Constants.GLOBAL_COMPANY_DELETE_START,
      payload: {
        company: company
      }
    });
  }

  protected getCompanies = (): CompanyInterface[] => {

    return this.props.app.companies
      .filter((company: CompanyInterface) => !!company && !company.removed)
      .filter((company: CompanyInterface) => !!company && !company.isAgency)
      .filter((company: CompanyInterface) => !!company && (this.state.filterValue ? company.name.toLowerCase().includes(this.state.filterValue.toLowerCase()) : true))
      .sort((company1: CompanyInterface, company2: CompanyInterface) => {
        if (company1.name.toLowerCase() > company2.name.toLowerCase()) {
          return 1;
        }

        if (company1.name.toLowerCase() < company2.name.toLowerCase()) {
          return -1;
        }

        return 0;
      })
      .map((company: CompanyInterface, key: number) => {
        // TODO: rewrite this part
        const properties = company.properties;

        let propertyStreetDetailsFirst;
        let propertyStreetDetailsSecond;
        let propertyStreetDetailsThird;

        if (properties[0]) {
          propertyStreetDetailsFirst = properties[0].address && properties[0].address.route ? `${properties[0].address.route} ${properties[0].address.fullAddress.streetNumber ? properties[0].address.fullAddress.streetNumber : ""}` : !properties[0].address.fullAddress.streetNumber && properties[0].address.formattedAddress;
        }
        if (properties[1]) {
          propertyStreetDetailsSecond = properties[1].address && properties[1].address.route ? `${properties[1].address.route} ${properties[1].address.fullAddress.streetNumber ? properties[1].address.fullAddress.streetNumber : ""}` : !properties[1].address.fullAddress.streetNumber && properties[1].address.formattedAddress;
        }
        if (properties[2]) {
          propertyStreetDetailsThird = properties[2].address && properties[2].address.route ? `${properties[2].address.route} ${properties[2].address.fullAddress.streetNumber ? properties[2].address.fullAddress.streetNumber : ""}` : !properties[2].address.fullAddress.streetNumber && properties[2].address.formattedAddress;
        }

        return (
          <TableRow
            hover
            key={key}
            className={`clickable-entity`}
            onClick={company?.isOwner ?
              this.redirect.bind(this, `/app/owner/update/${company.id}`) :
              company?.isAgency ?
                this.redirect.bind(this, `/app/agency/update/${company.id}`) :
                this.redirect.bind(this, `/app/company/update/${company.id}`)
            }
          >
            {/* <TableCell>
              <SubscriptionIcon entity={company} {...this.props} />
            </TableCell> */}
            <TableCell style={{ width: "50px" }}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                {company.renderAvatar()}
              </div>
            </TableCell>
            <TableCell style={{ width: "35%" }}>{company.displayName}</TableCell>
            <TableCell style={{ width: "60%" }}>{`${propertyStreetDetailsFirst ? `${propertyStreetDetailsFirst}` : ""} ${propertyStreetDetailsSecond ? `, ${propertyStreetDetailsSecond}` : ""} ${propertyStreetDetailsThird ? `, ${propertyStreetDetailsThird}` : ""}`}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, company)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedCompany && this.selectedCompany.id === company.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={this.selectedCompany?.isOwner ?
                      this.redirect.bind(this, `/app/owner/update/${this.selectedCompany && this.selectedCompany.id}`) :
                      this.selectedCompany?.isAgency ?
                        this.redirect.bind(this, `/app/agency/update/${this.selectedCompany && this.selectedCompany.id}`) :
                        this.redirect.bind(this, `/app/company/update/${this.selectedCompany && this.selectedCompany.id}`)
                    }
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={this.openPrompt}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public setFilterValue = (event: any): void => {
    const filterValue: string = event.target.value;

    this.setState({
      filterValue: filterValue
    }, () => {
      this.props.dispatch({
        type: Constants.COMPANIES_FILTER_SEARCH_UPDATE_STATE,
        payload: {
          filter: this.state.filterValue
        }
      });
    });
    // Search.search(event.currentTarget.value, this.props.objectField, this.props.searchParameter).then(results => {
    //   let filteredResults = results;
    //   if (typeof this.props.filterResults === "function") {
    //     filteredResults = this.props.filterResults.apply(this, [results]);
    //   }

    //   this.setState({
    //     results: filteredResults
    //   })
    // });
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-finance full-width has-general-page-header ${this.state.companiesSeparatePage ? "" : "has-general-page-header with-tabs"} ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <div style={{ padding: "0 40px", display: "flex", justifyContent: "space-between" }}>
              <h1 style={{ padding: "24px 0" }}>{this.state.companiesSeparatePage ? this.trans("title-companies") : this.trans("title-contacts")}</h1>
              <div className="button-container">
                {
                  !this.state.companiesSeparatePage &&
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.redirect("/app/person/create")}
                  >
                    {this.trans("button-add-person")}
                  </Button>
                }
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.redirect("/app/company/create")}
                >
                  {this.trans("button-new-company")}
                </Button>
              </div>
            </div>
            {
              !this.state.companiesSeparatePage &&
              <TabsComponent
                activeTab={1}
                {...this.props}
              />
            }
          </div>
          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <h3 className="card-title" style={{ flexDirection: "column", display: "flex"}}>
                  {this.trans("title-companies")}
                </h3>
              </div>

              <div>
                <div
                  className="list-filters-wrapper"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center"
                  }}
                >
                  <div className="table-filterer">
                    <TextField
                      autoComplete="off"
                      type="text"
                      style={{ color: "rgb(0, 188, 212)" }}
                      label={this.trans("label-search")}
                      value={this.state.filterValue}
                      onChange={this.setFilterValue}
                      variant="standard"
                      error={false}
                      inputRef={this.textFieldRef}
                    />
                    {
                      this.state.filterValue !== "" &&
                      <div className="icon icon-ic-close clear-button clear-button-search" onClick={() => this.setState({ filterValue: "" })}></div>
                    }
                    {
                      this.state.searchInProgress &&
                      <div className="search-loader">
                        <CircularProgress size={20} />
                      </div>
                    }
                  </div>
                </div>
                <TableComponent
                  {...this.props}
                  className={"persons-listing-table with-first-border listing-table"}
                  paginator={{
                    name: "Companies",
                    path: this.props.app.paginator
                  }}
                  dispatch={this.props.dispatch}
                  entities={this.props.app.companies}
                  isFetched={this.props.app.loadedEntities.includes(Constants.GLOBAL_COMPANY_LIST_SUCCESS)}
                  rows={this.getCompanies()}
                  isChildListingTable={false}
                  subtitle={this.trans("no-companies-to-list")}
                  ignoreFirstCellClick={true}
                  headers={["", this.trans("label-name"), this.trans("title-addresses"), ""]}
                  filtering={this.state.filterValue?.length > 0}
                />
              </div>
            </Card>
          </div>
        </div>

        <DeleteEntityPrompt
          {...this.props}
          entityName={'contact-company-remove-dialog'}
          isOpen={this.state.isDeletePromptOpen}
          onCancel={this.closePrompt}
          onDelete={() => this.delete(this.selectedCompany)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    // companies: state.companies,
    component: state.companies,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Companies
);
